var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{class:_vm.className,attrs:{"src":_vm.imageUrl,"alt":_vm.alt},on:{"error":_vm.onError}})
}
var staticRenderFns = []

export { render, staticRenderFns }